if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
				this.formInputID = this.form.querySelector(`[name='id']`) || this.form.querySelector(`[name='items[0][id]']`);
        this.formInputID.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector('cart-notification');
				this.cart = document.querySelector('cart-drawer-z');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

				if (this.querySelector('input[name="error_adhesion"]')) {
					this.submitButton.setAttribute('aria-disabled', true);
					this.handleErrorMessage(window.cartStrings.error_limit_adhesion_customer);
					return;
				}

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

							if (response.message !== window.cartStrings.error_limit_adhesion && response.message !== window.cartStrings.error_limit_adhesion_customer) {
								const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
								const notSoldOutIcon = this.submitButton.querySelector('.sold-out-message + .icon-cart');
								if (!soldOutMessage) return;
								this.submitButton.setAttribute('aria-disabled', true);
								this.submitButton.querySelector('span').classList.add('hidden');
								soldOutMessage.classList.remove('hidden');
								notSoldOutIcon?.classList.add('hidden');
							}

              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

						if (!this.error) {
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: 'product-form',
								productVariantId: formData.get('id'),
								cartData: response
							});

							//Reload page if Locksmith locked and card purple produt is added to cart
							if (Locksmith && Locksmith.path == "/collections/collection-test-vp" && Locksmith.state.locked) {
								const clubCardId = 50104156291345;
								const clubCardInCart = response.items.some(item => item.id === clubCardId);
								if (clubCardInCart) {
									window.location.reload();
								}
							}
						}

            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
